module.exports = __webpack_public_path__ + "static/img/reporticon10.61076a4e.png";